module.exports = __webpack_public_path__ + "img/download-data-base.0d748810.svg";